import authenticate from "@/store";
import { mapState } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapState({
      
    })
  },
  watch: {
    
  },
  created() {
    
  },
  mounted() {
    $("#load").fadeOut();
    $("#loading").delay(0).fadeOut("slow");
  },
  data: () => ({
    //
  }),
  methods: {
    //
  },
  components: {
    //
  }
};
